module.exports = __webpack_public_path__ + "media/images/lavita_banner/composed_banner/banner__sponsor__bottle--de-aa6fec5038e83a986d5fc986586fede6.png";